import { IsOptional, IsString } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateTeachingStaffRoleDto {
  @ApiPropertyOptional({ type: 'string', description: 'Code du rôle du personnel enseignant' })
  @IsOptional()
  @IsString()
  code?: string

  @ApiPropertyOptional({ type: 'string', description: 'Nom du rôle du personnel enseignant' })
  @IsOptional()
  @IsString()
  name?: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string
}
